import { createSelector } from 'reselect'

export const getAssets = createSelector([
  (state) => state.assets.assets
],
  (assets) => assets
)
